export const balanceBonus = {
  balanceBonus_title: "Bono",
  balanceBonus_statusActive: "Activo",
  balanceBonus_statusUnlocked: "Desbloqueado",
  balanceBonus_explain: "Jugable solo en slots y lotería. No es retirable.",
  balanceBonus_progressLabel: "Progreso de apuesta",
  balanceBonus_wageringRemaining: "Apuesta {{amount}} más para desbloquear tus ganancias",
  balanceBonus_wageringMet: "¡Ganancias desbloqueadas!",
  balanceBonus_expires: "Vence el {{date}}",
};

export default balanceBonus;
